module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-present_d28461de46dfbc2d2dd9967c8964ba69.png";